import { FC } from 'react';
import {
  TableRow, TableHead, TableCell, TableSortLabel, Checkbox, Box,
} from '@mui/material';
import { Sort } from '../../../interfaces/apiRequest.interface';
import { RequestQuerySortTypesEnum } from '../../../consts/enums';
import { CustomTooltip } from '../../CustomTooltip';
import style from './style';

export interface Header {
  key: string,
  value: string,
  isSortable?: boolean,
}

interface TableHeadContainerProps {
  headers: Header[];
  order: Sort,
  orderHandler: (val: Sort) => void,
  hasSelectAll?: boolean,
  onSelectAll?: () => void,
  isAllSelected? : boolean,
}

const DESC = 'desc';
const ASC = 'asc';

const TableHeadContainer:FC<TableHeadContainerProps> = ({
  headers,
  order,
  orderHandler,
  hasSelectAll = false,
  onSelectAll,
  isAllSelected,
}): JSX.Element => {
  const onClick = (key: string, direc: string) => () => {
    const newOrder = {
      [key]: direc === RequestQuerySortTypesEnum.Descendant ?
        RequestQuerySortTypesEnum.Ascendant : RequestQuerySortTypesEnum.Descendant,
    };
    orderHandler(newOrder);
  };

  const renderHeaderRows = () => headers.map(
    ({ key, value, isSortable }) => {
      return (
        <TableCell
          key={ key }
        >
          <TableSortLabel
            disabled={ !isSortable }
            active={ !!order[key] }
            direction={ order[key] === RequestQuerySortTypesEnum.Descendant ? DESC : ASC }
            onClick={ onClick(key, order[key]) }
          >
            <CustomTooltip
              title={ value }
            >
              <Box>
                {value}
              </Box>
            </CustomTooltip>
          </TableSortLabel>
        </TableCell>
      );
    });

  return (
    <TableHead sx={ style.head.sx }>
      <TableRow>
        {hasSelectAll && (
          <TableCell sx={ style.actionCell.sx }>
            <Checkbox
              checked={ isAllSelected }
              onChange={ onSelectAll }
            />
          </TableCell>
        )}
        { renderHeaderRows() }
      </TableRow>
    </TableHead>
  );
};

TableHeadContainer.defaultProps = {
  hasSelectAll: false,
  isAllSelected: false,
  onSelectAll: () => { /* beep */ },
};

export default TableHeadContainer;
